export default __webpack_public_path__ + "static/media/bbb-logo.58fde292.webp";